<template>
    <div class="box">
        <CustomTable
            ref="table"
            id_table="tiers_horse_stationnement"
            :items="horses"
            :busy.sync="table_busy"
            primaryKey="horse_id"
            :externSlotColumns="['horse_nom']"
        >
        	<template v-slot:[`custom-slot-cell(horse_nom)`]="{ data }">
        		<router-link :to="{ name: 'horseFiche', params: { horse_id: data.horse_id }}">
	        		<strike v-if="data.horse_inactive">{{ data.horse_nom }}</strike>
	        		<template v-else>{{ data.horse_nom }}</template>
	        	</router-link>
			</template>
        </CustomTable>
    </div>  
</template>

<script type="text/javascript">
    import HorseMixin from "@/mixins/Horse.js"

	export default {
		name: 'HorseStationnement',
		mixins: [HorseMixin],
		props: ['tiers'],
		data () {
			return {
				horses: [],
				table_busy: false,
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
				this.table_busy = true
				this.horses = await this.getHorsesStationnementByTiers(this.tiers.tiers_id)
				this.table_busy = false
			},
		},

		components: {
			CustomTable : () => import('GroomyRoot/components/Table/CustomTable'),
		}
	}

</script>